import CountUp from "react-countup";
import PieChart from "./PieChart";
import CustomLoader from "../custom/CustomLoader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const DashboardItem = ({
  title,
  isLoading,
  chartId,
  logged,
  total,
  loggedLabel = "Logged In",
  notLoggedLabel = "Not Logged In",
  customGraph = null,
  onLoggedClick = null,
  onNotLoggedClick = null,
  onTotalClick = null,
}) => {
  const safeLogged = logged < 0 ? 0 : logged;
  const safeNotLogged = total - logged < 0 ? 0 : total - logged;
  const safeTotal = total < 0 ? 0 : total;

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        <div className="align-self-center"></div>
      </div>
      <div
        className={isLoading ? "card-body p-0 mh-350" : "card-body p-0 mh-350"}
      >
        {isLoading ? (
          <CustomLoader />
        ) : (
          <div className="graph">
            {customGraph ? (
              customGraph
            ) : (
              <PieChart
                chartId={chartId}
                logged={safeLogged}
                total={safeTotal}
                loggedLabel={loggedLabel}
                nonLoggedLabel={notLoggedLabel}
              />
            )}
          </div>
        )}

        <div className="counters">
          <div className="row">
            <div className="col-6 col-md-4">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-logged-${chartId}`}>
                    See details and Export
                  </Tooltip>
                }
              >
                <div
                  className="counter-item"
                  onClick={onLoggedClick}
                  style={{
                    cursor: onLoggedClick ? "pointer" : "default",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (onLoggedClick) {
                      e.currentTarget.style.backgroundColor = "#f0f8ff";
                      e.currentTarget.style.transform = "scale(1.02)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (onLoggedClick) {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.transform = "scale(1)";
                    }
                  }}
                >
                  <label
                    style={{ cursor: onLoggedClick ? "pointer" : "default" }}
                  >
                    {loggedLabel}
                  </label>
                  <CountUp
                    end={safeLogged}
                    duration={1.75}
                    className="counter-up"
                  />
                </div>
              </OverlayTrigger>
              {/* <div
                className="counter-item"
                onClick={onLoggedClick}
                style={{
                  cursor: onLoggedClick ? "pointer" : "default",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  if (onLoggedClick) {
                    e.currentTarget.style.backgroundColor = "#f0f8ff";
                    e.currentTarget.style.transform = "scale(1.02)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (onLoggedClick) {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.transform = "scale(1)";
                  }
                }}
              >
                <label
                  style={{ cursor: onLoggedClick ? "pointer" : "default" }}
                >
                  {loggedLabel}
                </label>
                <CountUp
                  end={safeLogged}
                  duration={1.75}
                  className="counter-up"
                />
              </div> */}
            </div>
            <div className="col-6 col-md-4 left-border">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-not-logged-${chartId}`}>
                    See details and Export
                  </Tooltip>
                }
              >
                <div
                  className="counter-item"
                  onClick={onNotLoggedClick}
                  style={{
                    cursor: onNotLoggedClick ? "pointer" : "default",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (onNotLoggedClick) {
                      e.currentTarget.style.backgroundColor = "#f0f8ff";
                      e.currentTarget.style.transform = "scale(1.02)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (onNotLoggedClick) {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.transform = "scale(1)";
                    }
                  }}
                >
                  <label
                    style={{ cursor: onNotLoggedClick ? "pointer" : "default" }}
                  >
                    {notLoggedLabel}
                  </label>
                  <CountUp
                    end={safeNotLogged}
                    duration={1.75}
                    className="counter-up"
                  />
                </div>
              </OverlayTrigger>
              {/* <div
                className="counter-item"
                onClick={onNotLoggedClick}
                style={{
                  cursor: onNotLoggedClick ? "pointer" : "default",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  if (onNotLoggedClick) {
                    e.currentTarget.style.backgroundColor = "#f0f8ff";
                    e.currentTarget.style.transform = "scale(1.02)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (onNotLoggedClick) {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.transform = "scale(1)";
                  }
                }}
              >
                <label
                  style={{ cursor: onNotLoggedClick ? "pointer" : "default" }}
                >
                  {notLoggedLabel}
                </label>
                <CountUp
                  end={safeNotLogged}
                  duration={1.75}
                  className="counter-up"
                />
              </div> */}
            </div>
            <div className="col-6 col-md-4 left-border">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-total-${chartId}`}>
                    See details and Export
                  </Tooltip>
                }
              >
                <div
                  className="counter-item"
                  onClick={onTotalClick}
                  style={{
                    cursor: onTotalClick ? "pointer" : "default",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (onTotalClick) {
                      e.currentTarget.style.backgroundColor = "#f0f8ff";
                      e.currentTarget.style.transform = "scale(1.02)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (onTotalClick) {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.transform = "scale(1)";
                    }
                  }}
                >
                  <label
                    style={{ cursor: onTotalClick ? "pointer" : "default" }}
                  >
                    Total
                  </label>
                  <CountUp
                    end={safeTotal}
                    duration={1.75}
                    className="counter-up"
                  />
                </div>
              </OverlayTrigger>
              {/* <div
                className="counter-item"
                onClick={onTotalClick}
                style={{
                  cursor: onTotalClick ? "pointer" : "default",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  if (onTotalClick) {
                    e.currentTarget.style.backgroundColor = "#f0f8ff";
                    e.currentTarget.style.transform = "scale(1.02)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (onTotalClick) {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.transform = "scale(1)";
                  }
                }}
              >
                <label style={{ cursor: onTotalClick ? "pointer" : "default" }}>
                  Total
                </label>
                <CountUp
                  end={safeTotal}
                  duration={1.75}
                  className="counter-up"
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardItem;
